import React, { useState } from "react";
import {
  Grid,
  Button,
  Typography,
  Stack,
  MenuItem,
  Select,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Checkbox,
  Paper,
  Box,
} from "@mui/material";
import CustomExpandMore from "../../../common/CustomExpandMore";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import Pen from "../../../assets/images/CourseManagement/pen.svg";
import Close from "../../../assets/images/CourseManagement/close.svg";

import { useStyles } from "./styles";
import { useNavigate } from "react-router-dom";

const rows = [
  {
    select: false,
    feeType: "Semester fee",
    year: "2022",
    semester: "semester 1",
    amount: 5000,
    department: "Mechanical",
    edit: true,
    close: false,
  },
  {
    select: false,
    feeType: "Exam fee",
    year: "2021",
    semester: "semester 2",
    amount: 20000,
    department: "IT",
    edit: true,
    close: false,
  },
  {
    select: false,
    feeType: "Lab fee",
    year: "2020",
    semester: "semester 3",
    amount: 15000,
    department: "ECE",
    edit: true,
    close: false,
  },
];

const columns = [
  {
    id: "select",
    label: "Select",
    align: "center",
    sortby: true,
  },
  {
    id: "feeType",
    label: "Fee Type",
    align: "center",
    sortby: true,
  },
  {
    id: "year",
    label: "Year",
    align: "center",
    sortby: true,
  },
  {
    id: "semester",
    label: "Semester",
    align: "center",
    sortby: true,
  },
  {
    id: "amount",
    label: "Amount",
    align: "center",
    sortby: true,
  },
  {
    id: "department",
    label: "Department",
    align: "center",
    sortby: true,
  },
  {
    id: "edit",
    label: "Edit",
    align: "center",
  },
  {
    id: "delete",
    label: "Delete",
    align: "center",
  },
];

const FeesSchema = Yup.object().shape({
  amount: Yup.string()
    .required("* Please enter Amount")
    .matches(/^0*[1-9]\d*$/, "Please enter valid number"),
});

const FeeManagement = (props) => {
  const classes = useStyles();
  const navigate = useNavigate();

  const initValues = {
    amount: "10000",
  };

  const editList = () => {
    navigate("/feeManagement/edit");
  };
  return (
    <Grid container className={classes.feesList}>
      <Grid item lg={4} xs={12}>
        <Stack className={classes.align}>
          <Formik
            validationSchema={FeesSchema}
            initialValues={initValues}
            validateOnBlur={false}
            validateOnChange={false}
            onSubmit={(values) => {}}
          >
            {(formik) => {
              const {
                errors,
                touched,
                handleChange,
                handleBlur,
                handleSubmit,
                values,
              } = formik;
              return (
                <form onSubmit={handleSubmit}>
                  <Stack>
                    <Typography className={classes.title} sx={{ pb: 2 }}>
                      Add Fee
                    </Typography>
                  </Stack>
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Fee type
                    </Typography>
                    <Select
                      id="type"
                      name="type"
                      placeholder="Choose Fee Type"
                      IconComponent={CustomExpandMore}
                      sx={{
                        width: 220,
                      }}
                    >
                      <MenuItem value="jeep">Jeep</MenuItem>
                      <MenuItem value="volkswagen">Volkswagen</MenuItem>
                      <MenuItem value="volvo">Volvo</MenuItem>
                      <MenuItem value="jaguar">Jaguar</MenuItem>
                      <MenuItem value="audi">Audi</MenuItem>
                    </Select>
                  </Stack>
                  <br />
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Amount
                    </Typography>
                    <TextField
                      id="amount"
                      name="amount"
                      // placeholder="Enter Title"
                      className={
                        errors.amount && touched.amount
                          ? classes.inputError
                          : classes.inputNoError
                      }
                      onChange={handleChange}
                      value={values.amount}
                    />
                    <ErrorMessage
                      name="amount"
                      component="span"
                      className={classes.error}
                    />
                  </Stack>
                  <br />
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Department
                    </Typography>
                    <Select
                      id="department"
                      name="department"
                      placeholder="Choose Department"
                      IconComponent={CustomExpandMore}
                      sx={{
                        width: 220,
                      }}
                    >
                      <MenuItem value="jeep">Jeep</MenuItem>
                      <MenuItem value="volkswagen">Volkswagen</MenuItem>
                      <MenuItem value="volvo">Volvo</MenuItem>
                      <MenuItem value="jaguar">Jaguar</MenuItem>
                      <MenuItem value="audi">Audi</MenuItem>
                    </Select>
                  </Stack>
                  <br />
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Year
                    </Typography>
                    <Select
                      id="year"
                      name="year"
                      placeholder="Choose Year"
                      IconComponent={CustomExpandMore}
                      sx={{
                        width: 220,
                      }}
                    >
                      <MenuItem value="jeep">Jeep</MenuItem>
                      <MenuItem value="volkswagen">Volkswagen</MenuItem>
                      <MenuItem value="volvo">Volvo</MenuItem>
                      <MenuItem value="jaguar">Jaguar</MenuItem>
                      <MenuItem value="audi">Audi</MenuItem>
                    </Select>
                  </Stack>
                  <br />
                  <Stack className={classes.formView}>
                    <Typography className={classes.input_label}>
                      Semester
                    </Typography>
                    <Select
                      id="semester"
                      name="semester"
                      placeholder="Choose Semester"
                      IconComponent={CustomExpandMore}
                      sx={{
                        width: 220,
                      }}
                    >
                      <MenuItem value="jeep">Jeep</MenuItem>
                      <MenuItem value="volkswagen">Volkswagen</MenuItem>
                      <MenuItem value="volvo">Volvo</MenuItem>
                      <MenuItem value="jaguar">Jaguar</MenuItem>
                      <MenuItem value="audi">Audi</MenuItem>
                    </Select>
                  </Stack>
                  <br />
                  <Button
                    type="submit"
                    sx={{
                      width: "100%",
                      px: 1,
                      py: 2,
                      borderRadius: "50px",
                      fontSize: "15px",
                    }}
                    className={classes.submit_btn}
                  >
                    Add Fee
                  </Button>
                </form>
              );
            }}
          </Formik>
        </Stack>
      </Grid>
      <Grid item lg={10} sm={12}>
        <Stack sx={{ my: 4 }}>
          <Box sx={{ width: "100%" }}>
            <Paper
              sx={{
                width: "100%",
                p: 4,
                borderRadius: "20px",
                filter: "drop-shadow(0px 4px 40px rgba(0, 0, 0, 0.08))",
                boxShadow: "none",
              }}
            >
              <Stack
                sx={{
                  flexDirection: "row",
                  justifyContent: "flex-start",
                  alignItems: "center",
                  py: 2,
                }}
                className={classes.add_new_staff_container}
              >
                <Typography className={classes.input_label}>
                  Filtered View
                </Typography>
                <Select
                  id="filter"
                  name="filter"
                  placeholder="Choose filter"
                  IconComponent={CustomExpandMore}
                  sx={{
                    width: 220,
                    marginLeft: "10px",
                  }}
                >
                  <MenuItem value="all">All</MenuItem>
                  <MenuItem value="volkswagen">Volkswagen</MenuItem>
                  <MenuItem value="volvo">Volvo</MenuItem>
                  <MenuItem value="jaguar">Jaguar</MenuItem>
                  <MenuItem value="audi">Audi</MenuItem>
                </Select>
              </Stack>
              <TableContainer sx={{ maxHeight: "440px" }}>
                <Table
                  aria-label="sticky table"
                  className={classes.root}
                  style={{ padding: 0 }}
                  stickyHeader
                >
                  <TableHead>
                    <TableRow classes={{ root: classes.thead }}>
                      {columns.map((column) => (
                        <TableCell
                          key={column.id}
                          align={column.align}
                          style={{
                            minWidth: column.minWidth,
                            paddingLeft: column.paddingLeft,
                          }}
                          classes={{ root: classes.columnData }}
                        >
                          {column.label}
                        </TableCell>
                      ))}
                    </TableRow>
                  </TableHead>

                  <TableBody classes={{ root: classes.tBody }}>
                    {rows.map((_el, index) => (
                      <TableRow role="checkbox" tabIndex={-1} key={index}>
                        {columns.map((column) => {
                          return (
                            <TableCell key={column.id} align={column.align}>
                              {column.id === "select" ? (
                                <Stack sx={{ alignItems: "center" }}>
                                  <Checkbox defaultChecked />
                                </Stack>
                              ) : column.id === "feeType" ? (
                                _el.feeType
                              ) : column.id === "year" ? (
                                _el.year
                              ) : column.id === "semester" ? (
                                _el.semester
                              ) : column.id === "amount" ? (
                                _el.amount
                              ) : column.id === "department" ? (
                                _el.department
                              ) : column.id === "edit" ? (
                                <Stack
                                  sx={{
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={editList}
                                >
                                  <img src={Pen} alt="pen" />
                                </Stack>
                              ) : (
                                <Stack
                                  sx={{
                                    alignItems: "center",
                                    cursor: "pointer",
                                  }}
                                  onClick={() => alert("delete")}
                                >
                                  <img src={Close} alt="close" />
                                </Stack>
                              )}
                            </TableCell>
                          );
                        })}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </Paper>
          </Box>
        </Stack>
      </Grid>
    </Grid>

    //     <Button
    //     type="submit"
    //     sx={{ px: 1, py: 1, borderRadius: "50px" }}
    //     className={classes.add_new_staff}
    //     onClick={editList}
    //   >
    //     Add new Student
    //   </Button>
  );
};

export default FeeManagement;
